// import { Box, Button } from "@mui/material";
import { Survey } from "survey-react-ui";

function SurveyForm({ surveyModel, isOnline = true }) {
  return (
    <div id="pdfContent" className={`pdfContent ${!isOnline ? "offline-mode" : ""}`}>
      {/* This button is just for Test sentry error handler  */}
      {/* <Box sx={{ display: "flex", justifyContent: "center", m: 2 }}>
        <Button
          variant="contained"
          color="primary"
          aria-label="This is your first error!"
          onClick={() => {
            throw new Error("This is your first error!");
          }}
        >
          Break the world
        </Button>
      </Box> */}

      <Survey
        model={surveyModel}
        id="surveyContainer"
      // data-testid="surveyContainer" // data-testid is added on useSurveyModel.js
      />
    </div>
  );
}

export default SurveyForm;
